export default __webpack_public_path__ + "static/media/feather-menu-close.521ebd8e.svg";